import * as React from "react";

function SvgComponent(
  props: { backgroundFillColor?: string } & React.SVGProps<SVGSVGElement>
) {
  const { backgroundFillColor, ...svgProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="100 100 1300 800"
      width={200}
      height={"auto"}
      {...svgProps}
    >
      <style>
        {
          ".prefix__shp1{fill:#2f2962}.prefix__shp2{fill:#f5bfa9}.prefix__shp3{fill:#bfddda}.prefix__shp5{fill:#e1916e}.prefix__shp6{fill:#bec1df}.prefix__shp7{fill:#bf847c}.prefix__shp8{fill:#fff}.prefix__shp9{fill:#434d91}.prefix__shp11{fill:#fadad4}.prefix__shp12{fill:#768ff6}.prefix__shp13{fill:#e4eff8}.prefix__shp14{fill:#dea89e}.prefix__shp15{fill:#6181e2}.prefix__shp16{fill:#9a593b}"
        }
      </style>
      <g id="prefix__BACKGROUND">
        <path
          id="prefix__&lt;Path&gt;"
          d="M1198.95 835.43c131.6-125.96 181.55-233.04 149.84-321.23-47.35-131.72-1025.72-335.95-1163.72-210.12-92 83.9-53.85 261.01 114.45 531.35h899.43z"
          fill={backgroundFillColor ?? "#fff"}
        />
      </g>
      <g id="prefix__OBJECTS">
        <g id="prefix__&lt;Group&gt;">
          <g id="prefix__&lt;Group&gt;">
            <g id="prefix__&lt;Group&gt;">
              <g id="prefix__&lt;Group&gt;">
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp1"
                  d="M375.38 312.85c23.07 13.39 37.25 28.74 42.52 46.04 12.68 41.56 2.22 107.41-28.42 99.28-24.88-6.59-5.2-61.31-19.37-75.48-14.17-14.16-31.07-29.05-14.17-69.49l19.44-.35z"
                />
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp1"
                  d="M375.6 313.32c-.11-.03-.18.13-.08.18 18.8 9.36 34.7 22.79 43.72 42.14 10.36 22.22 10.03 47.91-.2 70.08-.11.24.24.45.36.21 20.83-41.55 2.81-98.31-43.8-112.61zM369.91 388.06c-3.45-6.7-8.82-12.02-13.14-18.11-11.84-16.71-8.34-37.18-1.23-55.02.1-.24-.29-.4-.4-.17-7.26 14.6-11.38 31.35-5.17 47.13 2.53 6.41 6.89 11.61 11.32 16.76 3.18 3.7 6.54 7.39 8.79 11.76 3.05 5.91 3.67 12.64 4.36 19.15.01.12.18.12.17 0-.43-7.47-1.23-14.75-4.7-21.5z"
                />
              </g>
              <g id="prefix__&lt;Group&gt;">
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp2"
                  d="M250.19 469.04c-23.22 45.58-34.74 74.35-34.59 86.32.24 17.95 4.44 33.67 11.21 35.44 6.78 1.76 34.34-32.51 38.78-37.44 4.43-4.94 23.02-64.88 28.81-75.8 5.79-10.91-30.88-23.72-44.21-8.52z"
                />
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp3"
                  d="M329.52 392.44c-13.5 5.39-35.81 13.05-41.71 19.24-5.91 6.19-63.83 81.4-65.07 88.12-1.24 6.73 27.08 33.06 40.01 35.53 12.93 2.47 25.46-2.87 29.51-5.87 2.69-2 15.11-47.67 37.26-137.02z"
                />
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp3"
                    d="M467.15 817.1c-35.04 24.67-129.36 30.43-147.46 26.24-18.06-4.17-61.75-21.11-65.75-26.96-3.97-5.82-8.92-83.47-2.92-126.43 2.78-19.98 10.42-52.84 17.69-82.4 6.25-25.48 12.19-48.47 14.44-58.66.76-3.42 1.1-5.38.9-5.53-1.53-.98-22.55-28.34-18.35-46.93 4.19-18.62 54.8-98 63.84-104 9-5.96 23.33-2.46 37.03-1.27 15.51 1.36 47.13 26 51.18 39.34 3.33 10.95 5.59 84.28 7.1 112.43.31 6.11.58 10.1.84 10.85 1.01 2.99 9.38 40.74 17.02 71.43 3.13 12.56 6.14 23.94 8.48 31.27 8.08 25.19 22.33 156.14 15.96 160.62z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M292.96 444.86c.26-.44-.4-.81-.68-.39-4.58 6.69-8.79 13.76-12.69 20.93 1.42-4.44 3.1-8.78 4.92-13.16.06-.15-.17-.24-.25-.11-3.11 5.34-5.21 11.22-6.77 17.22-.53 1.02-1.08 2.03-1.61 3.04-4.23 8.21-9.05 17.23-10.85 26.38-3.08 15.64 7.89 34.61 18.53 45.42.4.41.97-.19.62-.62-11.76-14.28-21.34-32.4-14.52-51.01 6.09-16.65 14.63-32.3 23.3-47.7z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    d="M442.71 625.21c-6.28.98-12.51 1.3-17.31 1.53-19.46.96-39.26-.84-58.46-3.91-20.32-3.24-40.27-8.54-59.38-16.12-7.64-3.01-13.2-3.74-21.45-2.35-4.35.73-8.66 1.68-13 2.46-1.48.26-2.93.53-4.4.73 6.25-25.48 12.19-48.47 14.44-58.66 9.73-2.46 19.75-4.11 29.3-6.17 15.2-3.27 28.29 10.75 44.47 10.48 20.73-.34 44.65-17.97 63.73-11.75 1.42.46 2.81.96 4.2 1.48.31 6.11.58 10.1.84 10.85 1.01 2.99 9.38 40.74 17.02 71.43z"
                    fill="#a1c9c4"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M321.88 554.77c-6.73-22.65-8.21-44.29-3.49-67.59 4.41-21.75 11.26-43.21 19.23-63.8.11-.27-.36-.47-.47-.2-9.44 21.74-16.51 45.47-20.72 68.89-3.58 19.88-4.14 42.83 4.24 61.72-.27 0-19.5 196.98 1.85 287.53.13.55.97.32.85-.24-20.61-91.18-1.39-285.97-1.49-286.31z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M337.2 454.23c-.62 1.08-3.02 2.1-3.81.38-.74-1.62.69-3.93 2.6-3.11.24.1.44-.21.21-.35-2.56-1.63-4.87 1.76-3.84 4.11 1 2.26 5.16 1.61 5.03-.98-.01-.1-.14-.15-.19-.05zM327.5 514.83c-.62 1.09-3.03 2.11-3.81.38-.74-1.62.68-3.92 2.6-3.1.24.1.43-.21.21-.36-2.56-1.63-4.87 1.77-3.84 4.11.99 2.27 5.16 1.62 5.03-.98-.01-.09-.14-.14-.19-.05zM331.97 546.86c-.62 1.09-3.02 2.11-3.81.38-.74-1.62.69-3.92 2.61-3.1.23.1.43-.21.2-.36-2.55-1.63-4.87 1.77-3.84 4.11 1 2.27 5.17 1.62 5.03-.98 0-.09-.13-.14-.19-.05zM329.33 610.7c-.62 1.09-3.02 2.11-3.81.38-.74-1.62.69-3.92 2.61-3.1.23.1.43-.21.2-.35-2.55-1.64-4.87 1.76-3.84 4.11 1 2.26 5.17 1.61 5.03-.99 0-.09-.14-.14-.19-.05zM324.86 677.81c-.62 1.09-3.03 2.1-3.81.38-.74-1.62.68-3.92 2.6-3.11.23.1.43-.2.2-.35-2.55-1.63-4.86 1.76-3.83 4.11.99 2.27 5.16 1.61 5.02-.98 0-.1-.13-.14-.18-.05zM324.86 740.45c-.62 1.09-3.03 2.11-3.81.38-.74-1.62.68-3.92 2.6-3.11.23.1.43-.2.2-.35-2.55-1.63-4.86 1.76-3.83 4.11.99 2.27 5.16 1.62 5.02-.98 0-.1-.13-.14-.18-.05zM331.97 576.72c-.62 1.08-3.02 2.1-3.81.38-.74-1.62.69-3.93 2.61-3.11.23.1.43-.21.2-.35-2.55-1.63-4.87 1.76-3.84 4.11 1 2.27 5.17 1.61 5.03-.98 0-.1-.13-.15-.19-.05zM326.69 643.43c-.62 1.09-3.02 2.11-3.81.38-.74-1.62.69-3.92 2.6-3.11.24.1.44-.2.21-.35-2.55-1.63-4.87 1.76-3.84 4.11 1 2.27 5.17 1.62 5.03-.98 0-.1-.14-.14-.19-.05zM324.86 709.85c-.62 1.09-3.03 2.11-3.81.38-.74-1.62.68-3.92 2.6-3.11.23.1.43-.2.2-.35-2.55-1.63-4.86 1.76-3.83 4.11.99 2.27 5.16 1.62 5.02-.98 0-.1-.13-.14-.18-.05zM327.5 804.87c-.62 1.09-3.03 2.11-3.81.38-.74-1.62.68-3.92 2.6-3.11.24.1.43-.2.21-.35-2.56-1.63-4.87 1.76-3.84 4.11.99 2.27 5.16 1.62 5.03-.98-.01-.1-.14-.14-.19-.05zM332.78 835.97c-.62 1.09-3.02 2.11-3.81.39-.74-1.63.69-3.93 2.6-3.11.24.1.44-.21.21-.35-2.56-1.63-4.87 1.76-3.84 4.11 1 2.26 5.16 1.61 5.03-.98-.01-.1-.14-.15-.19-.06zM324.86 770.81c-.62 1.09-3.03 2.11-3.81.38-.74-1.62.68-3.92 2.6-3.1.23.1.43-.21.2-.36-2.55-1.63-4.86 1.77-3.83 4.11.99 2.27 5.16 1.62 5.02-.98 0-.09-.13-.14-.18-.05zM330.14 484.55c-.62 1.09-3.02 2.1-3.81.38-.74-1.62.69-3.92 2.6-3.11.24.1.43-.2.21-.35-2.56-1.63-4.87 1.76-3.84 4.11.99 2.27 5.16 1.61 5.03-.98-.01-.1-.14-.14-.19-.05z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M327.74 543.31c-11.91-2.65-22.48.79-34.08 2.84-.1.02-.08.18.02.18 4.77.07 9.17-1.13 13.86-1.83 6.77-1.02 13.27-.63 20.07-.23.55.03.67-.84.13-.96zM385.39 542.6c-10.78 8.4-23.16 11.84-36.62 8.72-10.7-2.47-20.1-7.1-31.19-3.88-.16.04-.14.33.05.31 14.46-1.53 27.14 7.42 41.44 7.24 10.14-.13 20.12-4.23 27.19-11.53.56-.58-.26-1.33-.87-.86z"
                    />
                  </g>
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp5"
                    d="M389.52 599.95l-92.26 6.86c-4.52.34-8.44-3.05-8.78-7.56l-9.3-125.04a8.193 8.193 0 017.56-8.77l92.27-6.86c4.51-.34 8.44 3.05 8.77 7.56l9.3 125.04a8.193 8.193 0 01-7.56 8.77z"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp6"
                      d="M356.31 468.68l-44.74 3.27a3.371 3.371 0 01-3.61-3.12l-.65-8.86a3.366 3.366 0 013.12-3.61l44.74-3.28a3.366 3.366 0 013.61 3.12l.65 8.87c.14 1.85-1.26 3.47-3.12 3.61z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp6"
                      d="M346.26 445.68l.59 8.02-6.34.46-.27-3.68a3.511 3.511 0 00-3.77-3.25l-8.37.61c-1.94.14-3.4 1.83-3.26 3.77l.27 3.68-6.34.46-.59-8.01c-.2-2.83 1.9-5.26 4.72-5.46l17.9-1.31c2.79-.21 5.26 1.89 5.46 4.71z"
                    />
                  </g>
                </g>
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp2"
                  d="M440.3 489.21c6.96 5.24 15.88 81.22 16.4 89.81.52 8.6-9.73 25.06-12.48 25.75-2.75.7-28.98-9.06-35.36-17.44-6.37-8.39-9.92-84.55-8.61-89.19 1.31-4.64 33.56-13.8 40.05-8.93z"
                />
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp3"
                    d="M396.51 406.38c3.41 4.41 34.31 20.86 40.05 31.78 5.75 10.92 25.61 90.84 27.49 95.5 1.88 4.66-21.78 17.25-33.99 19.44-12.22 2.19-29.22-2.42-35.23-5.67-4.01-2.17-3.45-49.18 1.68-141.05z"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M391.29 473.72c-.02-.16-.26-.17-.25 0 1.34 24.56 1.85 49.22 1.17 73.81-.03 1.01 1.51 1 1.56 0 1.19-24.71.48-49.25-2.48-73.81zM425.08 437.01c-16.22 5.79-27.96 19.59-30.48 36.69-.03.19.25.27.28.08 3.14-16.66 14.35-30.54 30.25-36.59.11-.04.06-.22-.05-.18z"
                    />
                  </g>
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp2"
                      d="M444.75 604.51c-5.56 3.85-62.65 6-91.17.93-16.13-2.87-39.9-9.79-57.56-16.39-13.61-5.09-23.59-10.01-23.68-12.77-.2-6.31 12.3-19.91 20.32-19.1 7.99.81 55.39-3.51 72.44-2.41 13.78.9 27.39 1.42 38.83 2.35 11.69.93 21.1 2.29 26.11 4.83 6.58 3.36 11.49 17.55 14.71 42.56z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp7"
                      d="M403.93 557.12c-4.29 3.33-8.83 6.31-13.29 9-13.64 8.25-28.69 14.04-44.18 17.75-16.19 3.91-33.53 6.25-50.44 5.18-13.61-5.09-23.59-10.01-23.68-12.77-.2-6.31 12.3-19.91 20.32-19.1 7.99.81 55.39-3.51 72.44-2.41 13.78.9 27.39 1.42 38.83 2.35zM405.43 556.67c-.14.01-.17.22-.03.25 15.03 2.97 24.08 11.22 31.79 24.07.25.41.99.15.81-.34-4.91-13.12-18.18-24.13-32.57-23.98z"
                    />
                  </g>
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp2"
                    d="M226.81 590.8c14.01 7.83 121.3-22 127.95-26.36 1.99-1.31 30.63-2.52 35.52-3.16 4.89-.63 13.18-5.9 13.66-8.81.47-2.91-.62-5.48-1.1-6.67-.49-1.18 2.77-5.76 2.44-7.85-.32-2.09-2.51-5.02-3.06-6.21-.55-1.18.72-6.41-.02-7.89-.73-1.49-4.09-3.25-5.13-4.55-1.03-1.29.98-3.04-1.33-4.42-6.54-3.94-38.9 13.07-43.83 14.72-4.92 1.65-50.18 2.09-61.92 3.44-11.74 1.34-31.08 2.57-43.31 13.51-8.15 7.29-14.77 22.04-19.87 44.25z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp7"
                    d="M270.76 535.15c-17.17-.38-30.07 15.9-36.68 29.94-.11.24.21.43.35.21 9.31-14.79 19.1-25.05 36.44-29.33.46-.12.35-.81-.11-.82z"
                  />
                </g>
              </g>
              <g id="prefix__&lt;Group&gt;">
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp3"
                    d="M351.69 373.17c-15.69 3.65-24.54 14.53-29.63 19.52-5.09 5-19.8 36.3-19.76 41.72.03 5.42 27.49-18.12 33.35-18.03 4.04.06 18.61 31.93 25.98 30.38 9.35-1.96 26.5-29.32 26.59-43.89.03-4.81-7.56-17.11-14.43-23.36-7.86-7.14-15.5-7.88-22.1-6.34z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M388.47 403.82c.01-.12-.17-.14-.19-.03-5.65 22.97-22.88 42.42-26.65 42.97-4.36.64-23.6-31.18-25.84-31.35-4.17-.33-32.12 19.02-32.51 18.73-.31-.23 3.33-13.1 16.59-38.35.06-.11-.1-.2-.17-.1-15.38 23.5-20.09 41.3-17.93 41.28 2.75-.03 21.67-13.48 33.15-19.45 5.46 7.65 21.81 31.4 25.8 31.41 7.68 0 26.6-28.07 27.75-45.11z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp2"
                      d="M382.63 337.77c-.72 7.21-1.52 15.02-2.42 23.41-.2 1.66-.37 3.35-.57 5.04-1.69 15.27-6.05 34.3-6.95 36.05-1.78 3.44-17.22 18.42-29.58 16.36-8.26-1.33-11.76-6.04-10.5-14.13l.22-6.29v-.08l.4-12.39 1.07-32.33 42.3-13.89 6.03-1.75z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp7"
                      d="M382.63 337.77c-.72 7.21-1.52 15.02-2.42 23.41-12.48 14.78-29.21 25.94-46.98 24.56l1.07-32.33 42.3-13.89 6.03-1.75z"
                    />
                  </g>
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M290.25 296.46c7.02 38.87 3.49 66.15-10.6 81.84 15.2-8.55 22.93-28 23.2-58.37l-12.6-23.47z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M312.57 244.92c-12.54 1.79-20.79 10.41-24.75 25.85-4.94 19.29 6.5 38.09 8.84 39.99 4.16 3.37 26.37-53.03 15.91-65.84z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp2"
                      d="M291.47 307.3c-3.17 57.26 28.71 62.19 38.36 64.36 10.95 2.47 54.2 3.19 63.27-53.43 9.08-56.63-16.54-76.2-42.1-78.95-25.57-2.75-56.36 10.76-59.53 68.02z"
                    />
                    <g id="prefix__&lt;Group&gt;">
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M338.68 313.65c.05-.14.27.23.24.39-.72 3.84-.9 8.35 2.39 10.18.11.05.07.25-.06.21-4.17-1.26-3.87-7.26-2.57-10.78z"
                        />
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M342.75 310.15c6.28.49 4.83 13.02-.98 12.56-5.73-.44-4.29-12.97.98-12.56z"
                        />
                      </g>
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M311.77 311.02c-.03-.15-.31.18-.31.34.07 3.91-.52 8.39-4.07 9.63-.11.04-.1.24.03.22 4.32-.54 5.04-6.5 4.35-10.19z"
                        />
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M308.35 306.89c-6.28-.58-6.96 12.01-1.15 12.54 5.72.52 6.4-12.06 1.15-12.54z"
                        />
                      </g>
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp7"
                        d="M330.2 341.51c-.92.94-1.82 2.22-3.23 2.37-1.36.14-2.97-.44-4.22-.89-.13-.05-.25.09-.17.2 1.05 1.48 3.2 2.37 5.01 2.01 1.76-.35 2.6-1.89 2.99-3.52.05-.23-.25-.3-.38-.17z"
                      />
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp7"
                          d="M318.39 328.75c-.67 3.87-1.04 6.72-1.1 8.55-.01.26.65.41 1.58.49.04.02.07.04.11.01 4.83.93 9.77-.58 12.86-4.44.2-.26-.14-.55-.39-.39-3.72 2.53-7.75 3.08-12.06 3-.17-.77 2.06-9.87 1.63-9.92-1.5-.18-4.5.74-6.29 1.19 1.75-12.14 5.43-23.9 6.99-36.02.05-.43-.57-.58-.71-.2-4.73 12.05-7.05 25.98-9.19 38.48-.28 1.55 5.45-.32 6.57-.75z"
                        />
                      </g>
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp1"
                        d="M306.49 296.52c1.35-.1 2.58-.42 3.9-.66 1.5-.27 2.72-.34 3.85-1.44.61-.59.62-1.84.1-2.49-1.21-1.51-3.13-1.63-4.94-1.37-1.97.27-3.41.99-4.76 2.44-1.31 1.41.07 3.66 1.85 3.52zM348.13 300.3c-1.31-.33-2.47-.86-3.74-1.32-1.42-.52-2.61-.78-3.55-2.06-.5-.69-.29-1.92.33-2.47 1.44-1.28 3.35-1.08 5.09-.53 1.9.61 3.2 1.56 4.29 3.22 1.05 1.6-.69 3.59-2.42 3.16z"
                      />
                    </g>
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp1"
                        d="M388.98 321.61c-6.33.36-11.23-8.03-14.72-25.15-42.24-7.35-62.81-24.52-61.69-51.54 24.79-17.87 48.48-16.98 71.07 2.67 33.88 29.46 14.01 73.53 5.34 74.02z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp1"
                        d="M377.09 296.63c-15.27-1.02-30.32-3.95-42.98-13.1-13.27-9.6-18.74-22.74-21.23-38.35-.02-.16-.24-.1-.25.03-1.77 14.47 8.07 29.53 18.95 38.15 12.69 10.06 29.48 14.52 45.51 13.93.43-.01.42-.63 0-.66z"
                      />
                    </g>
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp2"
                        d="M403.96 331.79c-.02.07-.05.15-.09.24-2.38 5.67-5.84 10.67-9.46 12.44-.17.09-.32.14-.49.22-6.28 2.56-10.66.97-13.14-4.8l2.68-15.31.02-.1c.21-.32.51-.75.91-1.28.35-.52.72-1.06 1.11-1.56.95-1.23 2.18-2.77 3.59-4.29.02-.04.04-.04.06-.06 1.95-2.16 4.25-4.31 6.61-5.74 2.7-1.66 5.47-2.38 7.92-1.14 4.89 2.49 3.87 12.68.28 21.38z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp7"
                        d="M401.03 317.87c.16-.02.19.19.06.25-6.6 2.92-9.92 9.22-12.18 15.72 1.91-2.53 4.57-3.97 7.96-1.71.18.12.02.4-.17.36-2.76-.5-4.72.04-6.5 2.29-1.26 1.59-2.09 3.58-2.98 5.41-.29.6-1.38.32-1.17-.38.01-.05.03-.1.05-.16-.44-8.51 5.81-20.64 14.93-21.78z"
                      />
                    </g>
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M374.26 296.46c7.02 38.87 3.49 66.15-10.59 81.84 15.2-8.55 22.93-28 23.19-58.37l-12.6-23.47z"
                    />
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp8"
                        d="M405.08 329.15c-2.05 8.49-6.47 15.39-11.58 21.49-7.29 8.75-17.7 12.9-27.96 16.37-1.02.34-1.32-1.39-.26-1.73 11.32-3.49 21.79-11.26 27.9-19.94.06 0 .06 0 .04-.02.41-.26.8-.56 1.19-.85 3.62-1.77 7.08-6.77 9.46-12.44.04-.09.07-.17.09-.24.41-.87.78-1.77 1.12-2.64zM395.76 311.54c-2.55 1.37-5.04 3.43-7.15 5.49-.02.02-.04.02-.06.06-1.28 1.1-2.61 2.54-3.87 4.1-.43.48-.83 1-1.21 1.5-.43.51-.76.91-.98 1.22l-.02.09c-2.9 3.89-5.35 7.79-6.45 8.94-.34.38-.93-.12-.7-.5 3.15-5.42 9.08-19.74 17.29-20.94 1.15-.17 2.21-.16 3.15.04z"
                      />
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp8"
                          d="M380.02 325.91c1.28-2.82-19.09 6.96-40.33 2.59-4.35-.89-16.46-5.78-23.2-5.78-6.74 0-14.63 5.47-23.95 6.47-3.18.35-.43 27.93 7.71 39.99 2.68 3.96 14.08 12.09 21.05 12.81 16.37 1.68 44.42-10 48.68-15.46 3.43-4.38-2.02-13.87 10.04-40.62z"
                        />
                      </g>
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp6"
                          d="M294.17 337.95c5.84-2.48 12.28-4.68 18.4-5.89 5.46-1.07 10.4.92 15.58 2.77 13.88 4.93 27.85 4.38 41.84.39.17-.05.23.23.07.3-11.19 4.91-23.34 5.61-35.01 2.91-6.37-1.47-12.73-4.9-19.32-4.49-7.19.45-14.19 3.87-21.3 5.11-.6.11-.85-.85-.26-1.1zM304.52 369.84c4.41 2.13 8.76 5.24 13.35 6.74 5.48 1.78 11.97-.02 17.39-1.3 10.26-2.4 20.1-6.62 30.13-10.08.08-.03.11.11.03.15-11.13 5.44-22.74 10.04-34.68 12.16-4 .71-8.43 1.73-12.42.53-4.82-1.45-9.62-5.03-13.9-7.91-.13-.09-.05-.36.1-.29zM297.67 347.23c10.44-3.07 20.15-2.31 30.75-.9 12.05 1.61 24.08 1.28 36.09-.67.12-.02.17.18.05.21-10.64 2.21-21.42 2.79-32.19 1.67-5.21-.54-10.39-1.52-15.61-1.88-6.47-.45-12.62.69-18.93 2.24-.37.09-.53-.56-.16-.67z"
                        />
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp6"
                          d="M300.13 357.8c9.95 5.38 19.56 7.7 30.54 6.69 10.83-1 21.26-5.09 31.62-8.65.14-.05.19.19.06.24-20.77 8.77-41.83 14.7-62.49 2.35-.41-.25-.14-.86.27-.63z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="prefix__&lt;Group&gt;">
              <g id="prefix__&lt;Group&gt;">
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp9"
                    d="M513.19 646.9c9.87 121.59 15.52 183.24 16.93 184.93h64.53V646.9h-81.46z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp9"
                    d="M682.42 646.9H566.58c18.71 50.9 29.08 78.05 31.11 81.43 2.03 3.38 8.12 37.88 18.27 103.5h66.46c.08-55.3.08-84.73 0-88.28-.13-5.33 6.72-77.25 0-96.65z"
                  />
                </g>
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp6"
                  d="M598.92 379.84c-14.73.61-26.34 8.48-33.34 13.95-6.99 5.47-42.28 38.78-45.2 48.74-2.92 9.96-6.71 217.3-2.85 223.63 3.86 6.33 44.72 21 62.75 22.09 18.04 1.09 96.33-13.49 102.51-19.22 6.18-5.72 20.83-205.55 17.6-217.8-3.24-12.25-53.21-51.73-63.18-63.27-4.42-5.12-31.9-8.39-38.29-8.12z"
                />
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M569.27 423.22c-.14 2.83 3.11 15.82 4.53 17.43 1.43 1.61 12.69 2.4 14.02 1.46 1.33-.93 7.67-14.13 7.91-16.65.24-2.53-9.01-13.58-12.91-14.23-3.9-.64-13.47 10.29-13.55 11.99z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M573.8 440.65c-12.17 89.23-18.6 136.87-19.31 142.93-1.06 9.08 19.56 63.19 23.05 64.42 3.48 1.22 22.92-54.02 24.13-60.05 1.21-6.02-12.58-141.52-13.69-146.32-.31-1.3-14.01-2.23-14.18-.98z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp8"
                    d="M550.71 789.64c-1.88 5.47-50.47-9.11-51.44-15.76-1-6.62 16.24-160.62 16.26-172.7.06-12.07-1.85-145.45 3.87-160.85 2.89-7.87 20.62-25.71 30.82-35.58 2.89-2.8 5.34-5.11 7.34-6.94-1.67 6.49-7.98 93.66-6.38 152.98.5 18.97.84 49.73 1 82.95.01.31-.01.58.01.83.29 70.34-.19 151.4-1.48 155.07z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp8"
                    d="M527.14 486.82c-.26-4.08 6.66-14.43 20.76-31.04-12.52 1.97-18.79 1.59-18.81-1.14 0-3.56 17.09-41.08 21.13-49.89 2.89-2.8 6.37-5.8 10.43-9.03-1.68 6.49-11.07 95.75-9.47 155.07.5 18.97.84 49.73 1 82.95-.84-18.89-24.64-140.89-25.04-146.92z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M527.53 485.01c6.13-10.23 21.63-29.8 21.55-29.72-.06 0-17.95.7-19.24-.75-.91-1.02 15.13-36.87 19.91-46.56.11-.23-.19-.43-.34-.21-8.76 12.85-23.96 47.42-20.85 48.44 3.16 1.03 12.65.96 17 .97-7.6 7.8-19.72 26.84-20.16 28.19-.38 1.2 7.35 47.11 11.43 69.09 4.4 23.72 8.05 50.8 13.58 74.27.1.46.73.27.68-.16-2.81-23.52-18.87-117.49-23.56-143.56z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp8"
                    d="M708.39 774.38c-38.63 30.05-90.34 22.38-92.17 18.22-1.07-2.48-4.06-79.02-5.06-154.47l-.03-1.01c-.64-51.33-.42-102.03 1.97-128.39 3.91-43.54 11.77-83.8 23.59-120.81.42 0 2.24 1.3 5 3.51l.03.03c14.77 11.87 56.26 50.09 55.83 57.2-.54 8.45-2.59 119.42.72 167.72 3.3 48.26 15.53 153.78 10.12 158z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M687.53 680.16c-.2-.68-1.81-.79-2.12-.73-17.98 3.21-35.69 7.1-53.94 8.59-.18.01-.2.28-.01.28 18.3.25 36.59-3 54.35-7.21.03 0 .04-.02.07-.02 1.12 4 2.07 8.04 2.87 12.12-16.61 4.47-32.86 5.94-49.95 7.21-.15.02-.16.23 0 .25 16.58 1.72 34.35-1.32 50.2-6.16 1.5 8.07 2.32 16.25 2.29 24.5-.02 4.48.94 14.9-2.22 18.55-3.82 4.42-12.8 6.49-18.26 7.54-6.9 1.32-14.13 1.34-21.02-.06-4.19-.85-7.43-1.52-9.9-6.1-1.47-2.72-6.48-35.34-7.61-48.18-.04-.35-.58-.39-.58-.01.21 14.87 2.46 38.4 6.27 48.66 3.74 10.09 21.14 9.12 29.71 8 6.96-.91 16.16-2.33 22.02-6.39 3.82-2.66 3.62-5.47 3.82-10.2.74-17.84-1.24-34.19-5.99-50.64zM668.25 517.51c-6.77-.58-34.87 1.01-42.09 1.8-.42.04-.33.7.07.71 7.21.23 38.79-1.47 39.94-.97.99.44.71 6.31.04 6.64-1.66.81-32.75 1.08-40.2 1.24-1.27.03-1.34 2.01-.06 1.98 13.97-.32 27.93-.87 41.89-1.58.53-.03.98-.39 1-.95.1-2.68-.26-8.84-.59-8.87z"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp8"
                      d="M631.83 449.69c-.32.74 19.84 20.26 20.95 23.1 1.11 2.88-27.12 78.94-33.09 101.97-3.97 15.33-6.82 36.45-8.53 63.37l-.03-1.01c-.64-51.33-.42-102.03 1.97-128.39 3.91-43.54 11.18-84.53 21.81-122.98.43 0 4.02 3.47 6.78 5.68l.03.03c.39 1.58 13.87 51.56 14.05 53.18.14 1.66-23.66 4.31-23.94 5.05z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M642.37 392.98c-.12-.48-.45-.35-.36.13 3.34 17.49 7.26 34.56 12.64 51.52-8.01 1.35-23.21 4.46-23.49 4.8-.51.64 6.1 8.61 9.51 12.12 3.77 3.89 7.39 8.21 11.67 11.54-11.14 25.07-34.67 102.11-36.95 115.01-2.37 13.42-3.47 27-4.33 40.59-.01.17.24.18.26.01 1.76-14.29 3.32-28.63 6.32-42.73 2.69-12.69 27.66-87.34 36.49-112.5.23-.67-18.49-20.18-21.85-23.49 7.63-1.18 24.33-3.78 24.12-4.49-4.95-17.4-9.65-34.95-14.03-52.51z"
                    />
                  </g>
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp8"
                    d="M663.65 588.9c-.13 3.46-.71 5.87-1.28 6.16-1.77.96-9.32 4.6-19.53 8.72-1.83.73-3.74 1.5-5.73 2.25-5.59 2.12-25.9 12.53-48.71 23.49-30.47 14.65-65.34 30.3-75.43 28.59-17.58-3-42.23-24.16-44.04-36.3-1.81-12.15 35.11-156.44 39.79-166.25 4.66-9.81 9.98-18.13 15.06-23.11l-7.65 158.78c.24-.17.8-.37 1.63-.69 5.7-2.03 24.56-7.24 46.23-12.91 36.43-9.54 80.77-20.4 83.64-19.5 1.03.35 2.04.74 2.95 1.19h.03c11.25 5.63 13.44 20.89 13.04 29.58z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    d="M511.76 523.73c.06 0 .06-.09.01-.09"
                    fill="none"
                    stroke="#2f2962"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={0.4}
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp6"
                    d="M642.84 603.78c-1.83.73-3.74 1.5-5.73 2.25-5.59 2.12-25.9 12.53-48.71 23.49-5.15-3.02-10.3-6.08-15.45-9.08-12.47-7.24-25.25-14.1-37.43-21.76-.96-.62-1.9-1.27-2.81-2-.76.03-1.52.07-2.14.1-3.98.14-12.34-.17-12.84-5.11-.03-.11-.08-.23-.08-.34.01-.11.04-.17.07-.25 0-.17.01-.34.04-.54 5.7-2.03 24.56-7.24 46.23-12.91 19.6-.77 38.72 2.64 56.76 11.83 6.55 3.32 15.09 8.2 22.09 14.32z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M664.75 588.99c-.1 1.55-.29 3.15-.54 4.83.13.37-.45.94-.88 1.19-21.21 12.27-85.67 41.15-101.6 48.2-9.36 4.18-41.32 19.49-51.18 14.69-.19-.12-.25-.32.01-.28.08 0 .17.03.25.03 9 1.39 43.41-12.88 77.2-28.36 5.66-2.57 11.31-5.19 16.83-7.76.17-.11.37-.19.54-.27 11.55-5.43 22.47-10.71 31.62-15.17.05-.03.08-.03.11-.06 1.86-.9 3.63-1.78 5.32-2.6 8.21-4.02 14.98-7.38 20.3-10.08.54-7.67.41-28.1-15.71-34.47-24.37 6.49-51.87 12.32-76.44 18.69-.85.2-1.7.43-2.55.66-12.87 3.39-25.76 6.81-38.63 10.32-4.17 1.12-7.87 2.39-11.34 4.37-2.18 1.2-4.22 2.69-6.23 4.58-4.52 4.26-8.85 8.66-13.56 12.72-.29.25-.62-.13-.38-.4 5.11-6.22 10.48-13.27 17.27-17.95-.7-19.32-1.08-38.71-1.55-58.09-.97-1.32-1.37-3.08-1.77-4.67-.59-2.1-.92-4.28-1.19-6.43-.05-.4.49-.55.59-.15.48 1.98 1.1 3.95 1.77 5.91.16.43.34.86.53 1.31-.21-8.06-.4-16.13-.67-24.19.01-.06.12-.08.14 0 3.21 21.99 3.89 44.66 4.01 67.18.05 6 .04 12.01.03 17.98 1.87-1.1 3.81-2.06 5.89-2.73 12.86-4.13 26.19-7.11 39.22-10.53 15.25-4.02 31.57-7.82 47.82-11.48.34-.08.71-.18 1.11-.25 10.24-2.29 20.42-4.58 30.26-6.82 1.93-.43 3.83-.88 5.73-1.3.2.01 1.96.45 4.29 1.74 5.49 2.98 14.72 10.94 13.38 29.64z"
                  />
                </g>
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp11"
                  d="M557.66 569.58c-3.88 2.7-8.4 7.84-11.91 13.03-2.97 4.34-5.3 8.72-6.06 11.65-1.79.21-3.97-.28-5.01-.45-3.92-.68-6.4-2.66-7.43-5.94l-9.57 2.73c-2.7-1.1-2.36-3.69 1.01-7.78-.08-1.65 1.39-3.5 4.4-5.53.37-1.68 2.49-3.28 6.37-4.8 1.21-1.6 4.04-2.82 8.5-3.66 4.2-.84 13.41 0 19.7.75z"
                />
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp8"
                  d="M728.55 615.4c.02 7.69-24.79 45.13-41.23 43.01-27.01-3.42-141.3-59.34-146.78-60.6-1.15-.29-1.34-1.59-.85-3.55.76-2.93 3.09-7.31 6.06-11.65 3.51-5.19 8.03-10.33 11.91-13.03 1.18-.81 2.27-1.37 3.29-1.68 7.31-2.23 75.4 9.68 103.86 15.15 7.4 1.43 12.1 2.41 12.41 2.59.39.01.89-10.06 1.39-25.15 1.03-29.48 2.16-73.48 3.39-131.99 8.53 8.73 25.81 25.65 28.98 31.6 3.21 5.96 17.51 147.6 17.57 155.3z"
                />
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M696.43 595.32c-5.4-3.61-10.49-7.07-16.51-9.43 3.91-.98 9.96 1.02 13.11 1.34.61.06.69-.81.17-1.01-3.31-1.27-7.26-1.97-10.82-2.03-1.22-.02-2.36.18-3.34.69 1.81-24.91 1.79-50.48-.94-75.28-.05-.44-.76-.35-.76.08-.01 6.64 0 13.28.03 19.91-.68-2.78-1.49-5.53-2.19-8.16-.04-.17-.29-.11-.26.06 1.19 5.97 1.19 12.26 2.49 18.19.07 15.07.14 30.15.03 45.24-14.34-5.23-97.14-19.6-116.21-17.41-1.51.17-2.84 1.15-3.44 1.6-.45.34-.39.81-.13.69.87-.4 2.45-1.43 4.29-1.44 20.28-.11 101.38 13.79 115.69 19.06.14.13.33.2.53.19 6.17 2.3 12.24 5.02 18.21 8.33.8.44.82-.1.05-.62zM701.05 653.16c-3.25 2.33-7.05 4.02-10.65 4.62-5.66.95-21.07-5.09-30.48-8.58-14.4-5.34-28.33-11.85-42.21-18.4-12.56-5.92-25.14-11.78-37.86-17.34-6.64-2.91-13.31-5.75-20.01-8.53-4.09-1.7-17.15-6.31-19.55-7.96-.73-.51-.25-2.09-.31-2.91-.02-.28-.46-.41-.54-.08-.48 2.05-.38 1.46-.59 3.58-.02.27.18.47.4.56 31.24 13.05 61.76 27.45 92.5 41.59 13.32 6.13 26.85 11.92 40.88 16.24 5.46 1.68 12.14 4.26 18.13 3.6 4.12-.45 7.98-2.35 10.81-6.02.24-.31-.19-.6-.52-.37z"
                  />
                </g>
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp11"
                  d="M701.16 582.04c.85 1.92.96 3.32.33 4.18-.63.86-2.02 1.95-4.18 3.26-11.25-2.05-17.95-3.32-20.09-3.84-.31-.18-5.01-1.16-12.41-2.59-.75-14.48-8.59-21.05-13.44-23.7 3.61.05 18.31.34 27.24 1.14 2.81.25 5.06.55 6.18.92 5.24 1.62 18.09 15.98 17.9 17.77-.13 1.2-.64 2.15-1.53 2.86z"
                />
              </g>
              <g id="prefix__&lt;Group&gt;">
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp1"
                  d="M637.54 393.11c-3.02-17.57-31.67-18.27-45.08-17.41-17.07 1.08-31.17 5.54-35.36 23.27-4.15 17.52-3.62 36.74-2.5 54.63.21 3.34-4.98 3.76-5.19.41-1.29-20.62-5.7-59.29 11.88-74.23 17.41-14.79 76.32-16.84 81.44 12.92.56 3.3-4.63 3.69-5.19.41z"
                />
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp12"
                    d="M540.86 464.54c.51 6.58 6.26 11.5 12.84 10.99 6.58-.52 11.5-6.27 10.99-12.85-.52-6.58-6.27-11.5-12.85-10.98-6.58.51-11.5 6.26-10.98 12.84z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp13"
                    d="M545.6 464.17a7.206 7.206 0 007.73 6.62c3.96-.31 6.92-3.78 6.61-7.74a7.192 7.192 0 10-14.34 1.12z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <g id="prefix__&lt;Group&gt;">
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp6"
                        d="M633.13 451.5c-.99 51.64 3.86 63.01 9.25 67.62 5.68 4.84 13.31 6.36 13.63 6.42l.69-3.56-.35 1.78.35-1.78c-.07-.01-7.03-1.41-11.96-5.62-3.9-3.33-8.96-13.66-7.98-64.79l-3.63-.07z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp12"
                        d="M651.37 520.64l-.86 3.16c-.32 1.18.38 2.41 1.56 2.74l7.82 2.13c1.18.33 2.41-.38 2.73-1.56l.87-3.15c.32-1.19-.38-2.42-1.56-2.74l-7.82-2.14c-1.18-.32-2.41.38-2.74 1.56z"
                      />
                    </g>
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp6"
                        d="M665.1 445.01c18.52 34.24 25.72 53.69 22.64 61.23-2.47 6.03-7.99 10.44-8.05 10.48l2.25 2.85c.25-.2 6.33-5.05 9.15-11.96 3.67-8.97-2.94-27.61-22.79-64.33l-3.2 1.73z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp12"
                        d="M683.81 513.09l2.21 2.41c.83.9.77 2.32-.13 3.15l-5.96 5.48c-.9.83-2.32.77-3.15-.13l-2.21-2.41c-.83-.9-.77-2.31.13-3.14l5.96-5.49c.9-.83 2.32-.77 3.15.13z"
                      />
                    </g>
                  </g>
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp12"
                    d="M669.13 441.46c-2.23-4.82-8.2-16.67-12.1-22.39-2.13-3.14-5.19-5.45-9.17-6.95-.71.1-1.9-6.13-2.77-11.25-.75-4.52-1.54-9.8-2.95-10.97-1.36-1.13-4.07-.57-4.9.93-.89 1.6.3 6.8 1.23 11.29 1.06 5.09 2.21 11.32 1.5 11.49-2.9 2.95-4.76 6.22-5.58 9.82-1.37 6.01-2.71 21.51-2.61 25.92.14 5.48 2 5.71 3.62 5.86 2.28.2 3.27-1.56 3.53-7.72.41-9.75 0-25.91 6.35-27.4v-.02c6.45-.89 12.96 14.75 17.18 23.32 2.65 5.37 3.98 5.63 6.04 4.6 1.44-.72 2.86-1.74.63-6.53z"
                  />
                </g>
              </g>
              <g id="prefix__&lt;Group&gt;">
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp6"
                    d="M614.25 363.67c4.84 2.06 21.46 24.13 20.83 27.31-.63 3.18 1.46 43.34-35.25 58.97l-18.01-33.89-17.96 27.79c-6.92-14.76-10.27-23.99-10.04-27.67.33-5.53 4.64-33.04 26.03-46.74 16.07-10.29 24.31-10.06 34.4-5.77z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M634.54 390.56c-1.89 21.95-11.4 50.57-34.26 58.12-6.29-10.79-12.68-21.34-18.05-32.62-.19-.41-.63-.37-.92-.14-.17.04-12.86 18.39-17.73 27.37-3.07-6.11-4.76-12.85-6.77-19.36-2.78-9.03-1.58-16.02 1.23-24.88.07-.22-.28-.38-.38-.16-3.26 7.25-5.43 14.44-3.29 22.29 2.1 7.76 4.48 16.23 8.34 23.32.13.24.34.29.55.28.16.06.36.04.48-.12 6.29-8.61 11.44-18.02 17.77-26.66 5.41 11.24 11.53 22.02 17.65 32.03.3.48 1.35.22 1.44.19 23.76-7.5 34.84-36.58 34.22-59.66 0-.18-.27-.18-.28 0z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp11"
                      d="M561.77 338.08l2.7 51.94v.09l.38 7.29c1.79 10.03 7.93 15.97 18.42 17.81 15.72 2.81 39.51-18.21 41.38-22.13.95-2.01 1.74-20.64 2.3-38.33.35-11.27.63-22.26.84-32.97l-7.37 1.82-58.65 14.48z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp14"
                      d="M561.77 338.08l2.7 51.94v.09c17.23-2.57 33.71-9.83 47.58-20.74a97.735 97.735 0 0014.9-14.62c.35-11.27.63-22.26.84-32.97l-7.37 1.82-58.65 14.48z"
                    />
                  </g>
                  <g id="prefix__&lt;Group&gt;">
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp11"
                        d="M637.56 249.2c10.87 24.51 1.28 85.88-17.36 106.71-12.77 14.27-40.57 18.71-61.28 10.3-9.41-3.82-17.36-10.29-21.76-19.7-14.1-30.12-1.3-102.35 13.79-113.71 26.65-20.06 73.32-13.58 86.61 16.4z"
                      />
                    </g>
                    <g id="prefix__&lt;Group&gt;">
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M588.9 304.49c.04-.15.28.2.27.36-.43 3.82-.28 8.27 3.08 9.82.11.05.08.24-.04.21-4.19-.93-4.33-6.84-3.31-10.39z"
                        />
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M592.64 300.76c6.2.02 5.69 12.42-.05 12.4-5.66-.02-5.15-12.42.05-12.4z"
                        />
                      </g>
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M558.87 302.3c-.02-.15-.3.17-.31.32-.03 3.85-.72 8.25-4.25 9.38-.11.04-.1.23.03.22 4.26-.42 5.12-6.27 4.53-9.92z"
                        />
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M555.61 298.14c-6.16-.72-7.15 11.65-1.45 12.32 5.62.66 6.61-11.71 1.45-12.32z"
                        />
                      </g>
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp14"
                        d="M583.55 339.13c-.95.86-1.92 2.06-3.32 2.12-1.34.06-2.88-.61-4.09-1.13-.12-.06-.25.07-.17.19.93 1.51 2.99 2.52 4.79 2.28 1.75-.23 2.67-1.7 3.16-3.27.06-.22-.23-.32-.37-.19z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp1"
                        d="M597.77 295.29c-1.67-.5-3.13-1.23-4.74-1.89-1.8-.75-3.32-1.15-4.45-2.85-.61-.91-.28-2.48.55-3.15 1.93-1.58 4.37-1.21 6.58-.41 2.4.88 4.03 2.17 5.33 4.36 1.27 2.13-1.07 4.59-3.27 3.94zM551.07 291.7c1.73-.21 3.29-.69 4.98-1.07 1.91-.44 3.47-.59 4.87-2.07.75-.8.68-2.4-.02-3.2-1.64-1.87-4.11-1.92-6.42-1.49-2.52.46-4.34 1.46-5.99 3.41-1.6 1.88.3 4.7 2.58 4.42z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp8"
                        d="M570.04 330.31c2.08 5.28 5.16 7.45 9.24 6.52 3.07-.71 3.87-4.17 2.38-10.39-4 2.96-7.88 4.25-11.62 3.87z"
                      />
                      <g id="prefix__&lt;Group&gt;">
                        <g id="prefix__&lt;Group&gt;">
                          <path
                            id="prefix__&lt;Path&gt;"
                            className="prefix__shp14"
                            d="M582.01 326.8c-2.29 3.25-5.52 4.94-8.97 5.46-1.54.25-3.15.23-4.71.02-.31-.02-.62-.06-.9-.14-.28-.04-.53-.09-.83-.16-.45-.08-.68-.47-.74-.89v-.03c.01-.14.02-.25.05-.39 0 0 .01-.01.01-.03l.02-.34c.02-1.97.19-4.45.51-7.44-1.1.49-6.72 2.75-6.57 1.2 1.29-12.76 2.73-26.95 6.7-39.37.11-.42.76-.3.7.12-.75 12.32-3.67 24.41-4.62 36.77 1.79-.6 4.71-1.71 6.25-1.62.42.14-1.06 8.65-.98 9.98 0 .04.01.09.02.15 4.95.84 8.75-.51 13.71-3.65.3-.21.59.06.35.36z"
                          />
                        </g>
                      </g>
                    </g>
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M548.24 249.95c-13.07 20.79-14.99 54.37-17.68 44.85-5.92-20.91-3.64-37.42 6.83-49.52 8.28 1.45 11.9 3 10.85 4.67z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M633.57 314.78c-15.82-3.14-21.42-21.54-16.79-55.19-12.04 5.95-26.59 7.85-43.64 5.72-25.91-3.23-39.93-14.23-48.12-32.06-2.68-5.82 11.37 2.38 17.54-.26 11-4.72 21.74-19.06 51.34-18.41 19.73.43 32.21 7.29 37.44 20.58 10.61 3.26 18.04 9.51 22.28 18.73 6.36 13.83-4.77 60.86-20.05 60.89z"
                    />
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp11"
                        d="M625.25 313.06c8.06-13.59 15.14-19 21.24-16.22 9.16 4.17 1.08 33.02-8.95 37.64-6.69 3.08-11.52 1.55-14.49-4.59l2.2-16.83z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp14"
                        d="M643.97 305.05c.17-.03.22.2.08.27-7.02 3.48-10.33 10.48-12.47 17.64 1.95-2.84 4.77-4.53 8.55-2.24.2.12.04.43-.17.4-3.01-.41-5.11.26-6.93 2.79-1.29 1.79-2.1 3.99-2.97 6-.29.68-1.49.42-1.3-.35.02-.05.03-.11.05-.17-.88-9.21 5.32-22.67 15.16-24.34z"
                      />
                    </g>
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp8"
                        d="M611.18 360.24c10.44-4.66 20.97-10.04 27.76-19.95 4.77-6.93 8.74-14.6 10.04-23.73-.9 3.32-2.23 6.68-3.99 9.77-1.87 3.25-4.16 6.18-6.87 8.39.02.03.02.03-.03.03-5.57 9.72-15.8 18.91-27.36 23.7-1.07.46-.59 2.24.45 1.79zM622.13 320.07c1.87-2.32 7.65-14.3 12.84-18.78.02-.01.04-.03.06-.05.8-.8 1.62-1.57 2.47-2.26 1.52-1.23 3.15-2.19 4.8-2.56-1.31-.56-2.83-.72-4.56-.4-7.99 1.52-13.37 17.47-16.3 23.52-.21.42.37.96.69.53z"
                      />
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp8"
                          d="M623.88 317.37c1.34-2.98-20.16 7.35-42.56 2.73-4.59-.94-17.37-6.09-24.48-6.09-7.12 0-15.45 5.76-25.28 6.83-3.36.36-.46 29.46 8.14 42.19 2.82 4.18 14.86 12.76 22.21 13.52 17.28 1.77 46.87-10.56 51.37-16.32 3.62-4.62-2.14-14.63 10.6-42.86z"
                        />
                      </g>
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp6"
                          d="M533.91 327.21c6.16-2.62 12.96-4.95 19.41-6.22 5.77-1.13 10.98.98 16.45 2.92 14.64 5.21 29.39 4.62 44.15.41.18-.05.24.25.07.33-11.81 5.17-24.63 5.92-36.94 3.06-6.72-1.55-13.44-5.17-20.39-4.74-7.59.48-14.97 4.09-22.48 5.4-.64.11-.9-.9-.27-1.16zM544.83 360.86c4.65 2.24 9.24 5.53 14.08 7.11 5.79 1.88 12.64-.02 18.36-1.37 10.83-2.54 21.21-6.98 31.79-10.64.09-.03.12.12.04.16-11.75 5.74-24 10.6-36.6 12.83-4.22.75-8.89 1.83-13.1.56-5.09-1.52-10.16-5.31-14.68-8.35-.13-.09-.04-.37.11-.3zM537.6 337c11.02-3.24 21.27-2.44 32.45-.95 12.72 1.7 25.41 1.35 38.09-.71.12-.02.18.2.05.22-11.23 2.33-22.6 2.95-33.97 1.77-5.5-.57-10.96-1.61-16.48-1.99-6.82-.47-13.31.73-19.97 2.37-.39.09-.56-.59-.17-.71z"
                        />
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp6"
                          d="M540.2 348.15c10.5 5.69 20.63 8.13 32.22 7.06 11.44-1.05 22.44-5.37 33.37-9.13.15-.05.2.2.07.26-21.92 9.26-44.14 15.51-65.95 2.48-.43-.26-.15-.9.29-.67z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="prefix__&lt;Group&gt;">
              <g id="prefix__&lt;Group&gt;">
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp12"
                    d="M1247.31 662.11l-10.95 77.71-.6 4.25-12.21 86.81h-91.48l1.32-68.62.08-4.38 1.82-95.77h112.02z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp12"
                    d="M1223.55 662.11c-.65 13.25-1.54 25.24-2.67 35.94-.1 1-.21 2.01-.31 2.95-.71 6.31-1.58 11.74-2.53 14.67-2.27 6.98-23.68 27-39 40.9-1.64 1.5-3.22 2.9-4.7 4.24-5.67 5.09-9.86 8.76-10.78 9.73-.69.71-1.9 3.54-3.41 7.57-.02.11-.05.19-.1.26-4.13 10.97-9.82 28.48-17.06 52.51h-108.12c-2.9-48.95-3.89-80.96-2.98-96.04.26-4.49 1.08-10.05 2.24-16.09 0-.1.03-.21.06-.31 3.04-16.27 7.78-35.04 14.23-56.33h175.13z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp15"
                    d="M1247.31 662.11l-10.95 77.71-.6 4.25c-20.02 7.38-40.53 13.66-61.42 16.74-13.53 2.01-27.19 2.69-40.95 1.45-4.11-.37-8.23-.89-12.34-1.61-32.78-5.72-61.15-21.94-86.92-41.9 0-.1.03-.21.06-.31 3.04-16.27 7.78-35.04 14.23-56.33h198.89z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M1209.67 733.05c-7.22 6.23-14.21 12.67-21.77 18.55-7.12 5.54-23.37 15.48-23.61 16.07-8.55 20.56-15.02 42.26-22.34 63.26-.18.5.65.85.9.36 9.98-19.41 19.14-40.96 23.2-62.33 7.95-3.22 15.22-8.96 21.92-14.03 8.23-6.24 16.05-13.17 22.49-21.13.43-.53-.24-1.23-.79-.75z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp12"
                    d="M1284.28 508.75c-.34 1.37-2.93 1.11-6.99.34-5.33-.97-13.24-2.84-21.97-3.08-.02-.03-.02-.03-.02 0-5.43-.13-11.16.34-16.83 2.05-.18.06-.34.08-.52.11h-.03c-9.88 1.04-22.38-35.41-37.5-109.36 10.08 4.78 27.82 11.05 36.05 20.92 8.25 9.91 50.45 78.26 47.81 89.02z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp11"
                    d="M1131.66 362.23l-23.4 2.31c3.39 15.82 1.93 26.37-4.38 31.64-9.46 7.91-38.8 30-43.42 37.25-4.61 7.25 12.2 154.14 4.29 178.59-7.91 24.46-16.48 47.98-10.55 57.32 5.93 9.33 63.95 29.77 97.57 29.77 33.62 0 75.81-16.49 85.04-40.88 9.23-24.39 15.82-126.57 8.57-167.45-7.25-40.87-27.36-83.72-37.9-87.02-10.55-3.29-36.59-2.81-39.73-33.3-1.85-18.02-13.88-20.76-36.09-8.23z"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp12"
                      d="M1254.61 567.95c-.08 3.96-.16 7.86-.26 11.74-2.08 84.25-8.25 138.36-11.6 142.97-3.51 4.83-99.76 29.01-131.4 23.29-31.65-5.7-76-46.57-79.33-52.29-2.82-4.88 19.47-44.23 25.79-83.54 1.11-6.78 1.72-13.16 1.67-18.86-.11-9.15-.53-22.2-1.09-36.89-1.84-47.28-5.09-111.54-3.74-117.69 1.74-8.04 35.23-34.73 36.92-34.41 3.03.61 68.11 42.64 71.62 40.87 3.53-1.76 20.67-48.99 22.2-49.23 1.53-.21 25.26 7.49 30.33 13.63 3.87 4.7 25.66 43.72 34.86 102.03 2.82 17.8 4.45 37.42 4.03 58.38z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M1192.62 406.05c-4.07 12.69-23.34 49.18-25.95 51.08-.47.34-40.28-10.8-82.25-45.8-.03-.03-.08.03-.05.06 23.01 22.1 50.81 37.91 82.54 47.92.26.08 22.22-33.78 26.18-53.13.07-.31-.37-.43-.47-.13z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp15"
                      d="M1254.61 567.95c-.08 3.96-.16 7.86-.26 11.74-.69.05-1.37.1-2.03.15-12.47 1.06-24.97 1.93-37.47 2.64-6.36.34-12.77.48-19.12.98-6.88.52-12.13 2.66-17.96 6.11-10.34 6.07-20.8 11.9-31.51 17.3-18.12 9.1-37.47 17.38-58.2 14.85-11.07-1.37-21.36-5.38-30.25-11.6 1.11-6.78 1.72-13.16 1.67-18.86-.11-9.15-.53-22.2-1.09-36.89 17.38-13.55 40.4-19.22 61.37-24.13 23.18-5.4 46.65-9.91 70.09-13.95 19.75-3.37 40.48-6.88 60.73-6.72 2.82 17.8 4.45 37.42 4.03 58.38z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M1243.65 480.41c-.4-5.96-1.83-11.67-3.3-17.45-.06-.23-.41-.15-.36.08.79 3.9 1.24 7.85 1.69 11.8-2.25-6.1-4.72-12.13-7.37-18.05-.16-.35-.65-.07-.52.28 7.23 18.21 11.9 37.09 16.59 56.06.18.72 1.18.44 1.09-.26-1.44-11.07-4.24-21.89-7.82-32.46z"
                    />
                  </g>
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp11"
                      d="M1274.84 562.25c-9.26 4.86-50.68 5.02-90.82 3.8-32.38-.97-63.92-2.82-77.08-3.8-29.45-2.21 37.79-32.09 63.29-37.36 25.5-5.28 53.74-10.55 55.06-10.55.98 0 8.65-4.03 12.63-6.17.19-.03.37-.05.55-.11 14.82-4.48 30.17-.58 38.82 1.03 4.22 18.62 8.62 47.31-2.45 53.16z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp14"
                      d="M1255.3 506.01c-3.51 3.66-9.15 6.51-12.9 9.86-11.23 10.02-39.66 42.43-58.38 50.18-32.38-.97-63.92-2.82-77.08-3.8-29.45-2.21 37.79-32.09 63.29-37.36 25.5-5.28 53.74-10.55 55.06-10.55.98 0 8.65-4.03 12.63-6.17h.03c.18-.03.34-.05.52-.11 5.67-1.71 11.4-2.18 16.83-2.05z"
                    />
                  </g>
                  <g id="prefix__&lt;Group&gt;">
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp11"
                        d="M1242.4 507.09c-12.63 5.27-26.02 13.4-47.12 34.94-21.1 21.54-83.51 68.11-107.25 63.29-10.81-2.22-20.72-9.71-28.82-18.22-9.7-10.16-16.85-21.73-19.96-27.48l68.14-29.01 2.43 2.45 1.02 1.06c6.6-6.15 77.4-34.73 99.39-39.11 21.97-4.4 44.83 6.81 32.17 12.08z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp14"
                        d="M1132.48 522.58c-9.32 3.78-18.89 8.64-26.38 15.48-8 7.31-12.66 17.38-17.83 26.72-.23.4.34.77.6.39 5.9-8.62 11.2-18.11 18.97-25.21 7.51-6.87 16.34-11.54 24.91-16.87.32-.2.07-.65-.27-.51zM1109.82 533.06c-14.27 10.13-37.32 29.67-50.61 54.04-9.7-10.16-16.85-21.73-19.96-27.48l68.14-29.01 2.43 2.45z"
                      />
                    </g>
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp12"
                      d="M1072.53 416.87c-9.35 8.66-37.12 33.58-42.16 51.92-5.4 19.62-4.74 89.28 1.41 109.5 1.6 5.28 31.5-16.15 44.51-24.57 13.01-8.42 32.48-17.57 35.93-20.59 2.29-2.01-10.94-40.77-39.69-116.26z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M1105.38 505.32c-.37-4.69-1.45-9.41-1.99-14.06-.05-.41-.69-.43-.66 0 .16 2.67.22 5.44.39 8.2-1.78-4.46-3.64-8.88-5.47-13.28-.13-.3-.62-.18-.5.14 5.72 15.14 8.84 31.13 13.93 46.46.35 1.04 1.76.59 1.61-.45-1.28-9.3-4.03-18.24-7.31-27.01zM1093.73 486.48c-11.33-22.43-36.51-32.86-59.49-24.42-.17.06-.09.33.09.28 23.13-7.42 47.34 2.27 58.93 24.44.26.49.71.19.47-.3z"
                    />
                  </g>
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp11"
                    d="M1123.61 526.51c1.27-.59-27.65-8.35-38.78-4.97-11.13 3.39-33.45 35.96-30.46 41.55 2.99 5.58 24.04-12.21 27.57-12.98 1.75-.38 16.32-8.59 26.2-14.33 6.66-4.45 11.82-7.54 15.47-9.27z"
                  />
                </g>
              </g>
              <g id="prefix__&lt;Group&gt;">
                <g id="prefix__&lt;Group&gt;">
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp11"
                      d="M1171.01 389.9c-.83 10.16-6.37 16.65-16.62 19.49-15.38 4.28-41.06-14.36-43.32-18.08-.81-1.35-2.33-11.15-3.97-23.01-.65-4.76-1.32-9.89-1.97-14.93a2549.2 2549.2 0 01-3.97-32.75l7.49 1.12 59.77 8.82 1.77 40.1.51 11.86v.09l.31 7.29z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp14"
                      d="M1170.19 370.66c-2.03.76-4.08 1.44-6.14 2-18.84 5.13-40.05 5.02-56.95-4.36-.65-4.76-1.32-9.89-1.97-14.93a2549.2 2549.2 0 01-3.97-32.75l7.49 1.12 59.77 8.82 1.77 40.1z"
                    />
                  </g>
                  <g id="prefix__&lt;Group&gt;">
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp11"
                        d="M1174.62 240.09c11.86 24.05 4.78 85.75-13 107.33-12.17 14.78-39.77 20.35-60.8 12.79-9.56-3.43-17.76-9.58-22.55-18.8-15.31-29.51-5.47-102.21 9.15-114.17 25.81-21.13 72.7-16.56 87.2 12.85z"
                      />
                    </g>
                    <g id="prefix__&lt;Group&gt;">
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M1128.72 291.79c.04-.14.29.2.28.36-.27 3.83.06 8.27 3.49 9.68.11.05.09.24-.04.22-4.22-.77-4.6-6.67-3.73-10.26z"
                        />
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M1132.31 287.92c6.2-.23 6.19 12.18.45 12.39-5.65.21-5.65-12.2-.45-12.39z"
                        />
                      </g>
                      <g id="prefix__&lt;Group&gt;">
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M1098.63 290.83c-.03-.14-.3.18-.3.34.13 3.85-.38 8.27-3.86 9.54-.11.04-.1.24.03.22 4.25-.6 4.86-6.48 4.13-10.1z"
                        />
                        <path
                          id="prefix__&lt;Path&gt;"
                          className="prefix__shp1"
                          d="M1095.2 286.82c-6.19-.47-6.67 11.93-.94 12.36 5.63.43 6.12-11.97.94-12.36z"
                        />
                      </g>
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp14"
                        d="M1122.79 323.96c-.92.9-1.84 2.14-3.24 2.26-1.34.11-2.9-.5-4.13-.97-.12-.05-.24.08-.17.19 1 1.48 3.1 2.4 4.88 2.09 1.74-.3 2.6-1.81 3.03-3.4.06-.22-.24-.3-.37-.17z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp1"
                        d="M1137.21 282.24c-1.69-.42-3.18-1.1-4.81-1.69-1.84-.67-3.37-1.02-4.57-2.66-.65-.89-.38-2.47.42-3.18 1.86-1.65 4.32-1.39 6.56-.67 2.44.78 4.12 2 5.51 4.14 1.35 2.07-.88 4.62-3.11 4.06zM1090.4 280.57c1.72-.28 3.26-.83 4.93-1.28 1.89-.51 3.45-.73 4.79-2.27.71-.82.58-2.42-.16-3.2-1.71-1.8-4.18-1.75-6.47-1.22-2.5.56-4.27 1.64-5.84 3.65-1.53 1.95.48 4.68 2.75 4.32z"
                      />
                      <g id="prefix__&lt;Group&gt;">
                        <g id="prefix__&lt;Group&gt;">
                          <path
                            id="prefix__&lt;Path&gt;"
                            className="prefix__shp14"
                            d="M1122.74 314.26c-2.15 3.33-5.31 5.16-8.73 5.82-1.53.31-3.14.36-4.71.21-.31 0-.62-.04-.9-.1-.28-.03-.54-.07-.85-.13-.44-.07-.69-.44-.77-.86v-.03c.01-.14.01-.25.04-.39v-.03l.01-.34c-.06-1.97.01-4.46.21-7.46-1.09.54-6.6 3.02-6.51 1.47.76-12.8 1.62-27.03 5.08-39.61.1-.42.74-.33.71.1-.25 12.33-2.67 24.53-3.12 36.92 1.76-.67 4.63-1.91 6.18-1.87.42.12-.71 8.69-.57 10.01 0 .04.01.09.02.14 4.98.64 8.73-.86 13.55-4.2.29-.22.6.04.36.35z"
                          />
                        </g>
                      </g>
                    </g>
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M1171.13 303.42c-9.37 0-5.56-29.94-8.43-42.13-2.53-10.74-15.26-19.72-27.79-13.85-7.68 3.6-19.39 8.62-30.3 5.46-10.92-3.17-12.85-15.32-19.01-13.91-3.78.86-7.23 6.26-10.36 16.2-1-21.91 8.22-37.4 27.64-46.48 25.82-12.06 53.24 1.06 58.88 4.23 5.63 3.17 16.71 9.13 23.87 20.18 7.74 11.97.28 70.3-14.5 70.3z"
                    />
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp11"
                        d="M1167.08 304.31c7.5-13.91 14.36-19.6 20.57-17.07 9.32 3.79 2.42 32.95-7.41 37.97-6.56 3.35-11.45 2.02-14.67-3.99l1.51-16.91z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp14"
                        d="M1185.47 295.55c.16-.04.22.19.08.26-6.87 3.76-9.89 10.89-11.74 18.13 1.84-2.92 4.59-4.72 8.46-2.58.2.11.05.43-.15.41-3.03-.29-5.1.47-6.82 3.06-1.22 1.84-1.94 4.07-2.73 6.12-.26.69-1.46.48-1.3-.29.01-.06.02-.12.04-.18-1.25-9.17 4.39-22.86 14.16-24.93z"
                      />
                    </g>
                  </g>
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp8"
                      d="M1152.29 350.92c10.44-4.67 20.96-10.05 27.75-19.95 4.77-6.93 8.74-14.6 10.05-23.74-.91 3.33-2.24 6.69-4 9.78-1.86 3.25-4.16 6.18-6.87 8.39.02.03.02.03-.03.03-5.57 9.72-15.8 18.91-27.36 23.7-1.06.45-.58 2.24.46 1.79zM1163.23 310.75c1.87-2.32 7.65-14.3 12.85-18.78.01-.02.03-.03.05-.05.8-.8 1.62-1.57 2.48-2.27 1.51-1.22 3.14-2.18 4.79-2.55-1.31-.56-2.82-.72-4.56-.4-7.99 1.52-13.37 17.47-16.3 23.52-.21.42.37.96.69.53z"
                    />
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp8"
                        d="M1164.98 308.05c1.34-2.98-20.15 7.35-42.56 2.73-4.59-.94-17.37-6.09-24.48-6.09-7.11 0-15.45 5.76-25.28 6.82-3.36.37-.45 29.47 8.14 42.2 2.82 4.18 14.86 12.76 22.21 13.52 17.28 1.77 46.87-10.56 51.38-16.32 3.61-4.62-2.14-14.63 10.59-42.86z"
                      />
                    </g>
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp6"
                        d="M1075.01 317.88c6.16-2.61 12.96-4.94 19.41-6.21 5.77-1.13 10.98.97 16.45 2.92 14.65 5.21 29.39 4.62 44.15.41.18-.05.24.25.08.32-11.81 5.18-24.64 5.93-36.95 3.07-6.72-1.55-13.43-5.17-20.39-4.74-7.59.48-14.97 4.09-22.48 5.4-.63.11-.89-.9-.27-1.17zM1085.93 351.54c4.66 2.24 9.24 5.53 14.09 7.11 5.78 1.88 12.63-.02 18.35-1.37 10.83-2.54 21.21-6.99 31.79-10.64.09-.03.12.12.04.16-11.75 5.74-24 10.6-36.6 12.83-4.22.75-8.89 1.83-13.1.56-5.09-1.53-10.16-5.31-14.68-8.35-.13-.09-.04-.38.11-.3zM1078.7 327.68c11.02-3.25 21.27-2.44 32.45-.95 12.72 1.7 25.41 1.35 38.09-.71.12-.02.18.2.05.22-11.23 2.33-22.6 2.95-33.97 1.77-5.5-.57-10.96-1.61-16.47-1.99-6.83-.47-13.32.73-19.98 2.36-.39.1-.56-.58-.17-.7z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp6"
                        d="M1081.3 338.83c10.5 5.68 20.64 8.13 32.22 7.06 11.44-1.05 22.44-5.37 33.38-9.13.14-.05.2.2.06.26-21.92 9.26-44.14 15.51-65.95 2.47-.43-.25-.14-.9.29-.66z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="prefix__&lt;Group&gt;">
              <g id="prefix__&lt;Group&gt;">
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp8"
                  d="M900.58 416.89c12.29 9.92 27.86 29.66 31.62 34.71 3.77 5.06 22.49 118.86 25.68 126.16 3.19 7.29 45.94 66.82 43.85 70.47-2.1 3.64-23.55 26.04-33.86 25.19-10.31-.85-48.14-68.07-55.44-76.47-4.86-5.59-8.82-65.61-11.85-180.06z"
                />
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp6"
                    d="M852.26 388.96c-24.71-.85-61.99 44.91-67.09 64.32-5.1 19.41 24.07 94.43 21.84 116.06-2.22 21.63-9.93 42.06-4.88 50.72 5.04 8.66 57.65 25.25 77.64 23.73 20-1.53 37.2-29.11 41.84-35.17 4.64-6.06-2.13-59.47-1.03-62.88 1.1-3.41 18.81-17.08 16-35.39-2.82-18.32-24.97-75.52-31.09-83.7-6.11-8.19-29.21-36.86-53.23-37.69z"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M891 537.72c-9.01 3.04-17.89 8.01-27.31 9.57-11.3 1.87-22.52-3.06-32.4-8-.28-.14-.54.25-.27.43 8.83 5.82 18.44 11.24 29.38 10.71 10.7-.52 21.75-6.74 31.11-11.37.72-.36.28-1.61-.51-1.34zM909.44 541.37c-9.11-.65-18.29 1.37-26.71 4.71-.42.17-.15.87.28.74 8.7-2.69 17.31-3.63 26.38-4.04.89-.04.96-1.35.05-1.41z"
                    />
                  </g>
                </g>
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp1"
                  d="M805 582.97c38.48 13.19 64.64 19.13 78.47 17.83 13.83-1.31 26.98-6.82 39.43-16.55 10.57 41.58 17.08 69.79 19.52 84.63 3.66 22.25 11.87 126.67 11.74 130.36-.12 3.69-27.76 33.97-74.23 32.37-46.48-1.61-115.1-24.88-119.35-30.19-4.24-5.32 21.92-142.53 28.69-167.41 4.51-16.58 9.75-33.6 15.73-51.04z"
                />
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp8"
                    d="M859.99 839.06c.41 8.88-54.38-.87-72.89-7.42-18.47-6.55-34.26-19.92-36.05-25.38-1.76-5.47 30.97-144.22 32.94-158.4 1.96-14.2 17.3-62.55 18.34-71.37 1.05-8.83-25.46-103.68-30.18-109.75-3.93-5.07 30.15-46.49 47.22-61.8 3.35-3.04 6.08-5.04 7.69-5.55.9-.29 2.12 1.99 3.63 6.18 7.65 21.51 21.88 93.49 28.31 130.53 3.03 17.41 3.75 66.77 3.57 120.71-.3 82.98-2.8 176.87-2.58 182.25z"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M829.66 649.13c-5.85 9.98-9.77 20.11-18.1 28.51-7.64 7.72-15.83 15.1-25.23 20.59-.24.14-.09.51.18.45 10.81-2.74 19.51-11.13 27.08-18.94 8-8.25 13.8-19.17 17.2-30.11.21-.67-.77-1.11-1.13-.5zM833.99 663.12c-7.08 18.53-20.12 30.58-36.51 41.19-.14.09-.02.3.12.22 16.08-9.12 32.29-22.51 37.08-41.21.11-.45-.53-.63-.69-.2z"
                    />
                  </g>
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp8"
                    d="M879 399.78c-2.92-1.77 26.78 89.81 23.67 151.25-3.11 61.44-4.94 285.41 1.3 290.05 6.24 4.65 48.1-23.94 55.34-34.03 7.24-10.09-9.42-147.67-16.54-169.58-7.12-21.91-13.75-41.5-15.52-47.47-1.76-5.97-5.96-41.78-4.94-43.71 1.03-1.93 15.02-14.99 17.33-31.9 2.3-16.91-34.2-89.81-36.68-94.57-2.48-4.76-22.03-18.86-23.96-20.04z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M931.48 602.48c-4.49-16.14-7.5-44.71-8.23-54.69 0-.01.01-.01.02-.01 8.76-9.9 18.73-24.21 17.46-38.14-.69-7.62-3.96-15.45-6.8-22.66-.46-6.12-2.78-12.13-5.14-17.72-.07-.18-.38-.06-.32.12 1.19 3.51 1.97 7.09 2.7 10.68-2.73-6.61-5.76-13.06-9.22-19.35-.13-.23-.47-.04-.36.2 5.85 13.64 11.91 27.45 15.78 41.82 4.37 16.25-4.98 31.72-15.47 43.58-.43.48 0 32.46 6.44 52.77 6.1 19.25 12.74 38.34 18.53 57.69.1.33.59.21.51-.12-4.18-18.37-10.86-36.04-15.9-54.17z"
                  />
                </g>
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp8"
                  d="M862.57 656.81c-2.93-.72-5-68.95-8.46-82.65-3.45-13.68-26.49-66.83-27.33-70.82-.87-3.96 16.76-29.2 15.81-29.97-.98-.77-22.99 9.55-25.26 6.75-2.04-2.49 3.12-62.85 5.09-75.39.23-1.36 4.4-9.24 5.65-6.71 15.74 31.68 24.5 101.04 30.93 138.08 3.03 17.41 3.75 66.77 3.57 120.71z"
                />
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M857.7 610.72c-.94-12.07-.46-24.44-3.2-36.29-4.09-17.7-26.94-69.13-26.81-69.42 2.61-5.99 12.97-26.46 14.84-30.95.26-.61.54-1.23-.79-.78-3.87 1.32-21 7.85-23.15 6.83-1.69-.8 2.11-71.88 6-79.22.21-.39-.51-.53-.7-.12-5.66 11.75-9.33 75.69-6.59 80.95.22.42.74.66 1.2.54 7.68-1.91 15.34-4.04 22.43-7.6-3.16 4.06-15.82 29.58-15.66 30.01 8.67 23.25 21.73 46.41 27.34 71.52 2.92 13.04 2.76 26.78 4.04 40.04 1.16 12.1 2.72 24.15 4.93 36.1.08.4.66.25.61-.14-1.71-13.8-3.41-27.6-4.49-41.47z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp8"
                    d="M879 399.78c-4.36.77 13.83 79.76 15.87 95.71 1.35 10.63 3.12 64.84 5.31 162.62 4.06-57.68 6.64-88.11 7.73-91.27 1.64-4.74 8.38-71.35 8.11-74.31-.27-2.97-20.57-24.72-20.9-25.84-.33-1.12 17.1 2.07 17.88.99.78-1.08-31.93-68.26-34-67.9z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M917.51 491.99c.02-.38-13.14-17.92-20.92-24.96 5.01.57 16.93 2.02 17.45 1.29 1.02-1.43-19.11-45.25-32.34-65-.07-.1-.23-.02-.17.08 11.36 20.51 20.87 41.88 30.15 63.37-5.63-.72-16.07-.55-16.08-.55-.34-.04-.64.33-.37.68 6.51 8.48 20.31 25.71 20.65 25.72-3.36 26.32-6.92 52.59-10.41 78.89-3.47 26.14-6.34 53.33-4.44 79.71.01.13.21.14.21.01-.09-26.91 2.35-53.03 6.1-79.66 3.72-26.37 8.94-52.94 10.17-79.58z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp8"
                    d="M790.31 436.65c-7.77 10.04-21.13 24.09-28.4 52.4-7.26 28.3-23.71 125.33-23.26 134.11.45 8.77 48.26 67.65 55.53 69.88 2.21.69 12.05-8.29 19.76-17.97 6.34-7.97 12.05-16.48 12.16-19.52.13-3.46-33.87-45.25-33.19-48.74.69-3.48 7.88-56.82 12.22-74.9 1.62-6.75-3.32-38.51-14.82-95.26z"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M782.62 457.48c-.11-.12-.29.05-.18.17 15.48 18.46 18.46 41.62 21.64 64.64.03.19.36.16.34-.03-2.1-22.83-5.59-47.3-21.8-64.78zM826.61 654.39c-7.66-12.02-16-23.6-24.61-34.97-1.98-2.63-4.05-6.29-6.64-8.9a10.29 10.29 0 00-2.21-2.84c.01-.03.03-.05.03-.08 2.48-17.98 6.33-35.87 9.28-53.83 1.35-3.15 2.6-6.35 3.98-9.48.11-.24-.28-.41-.42-.19-.96 1.63-1.9 3.28-2.8 4.94.88-5.68 1.66-11.37 2.25-17.07.02-.2-.29-.25-.34-.06-6.25 23.68-10.67 49.62-13.9 74.32-2.78-1.74-6.19-2.74-9.17-3.49-.12-.03-.17.14-.06.18 2.58.97 5.2 1.98 7.53 3.47.57.36 1.07.77 1.53 1.19.01.03.01.06.01.09-3.96-1.39-9.82-1.13-13.63-1.24-.19-.01-.25.28-.06.33 4.08 1.07 10.76.92 14.22 3.2 4.13 2.72 7.54 9.21 10.54 13.19 7.92 10.5 15.49 21.26 23.17 31.94.54.75 1.82.12 1.3-.7zM793.94 692.21c-5.31-5.6-11.23-10.53-16.84-15.81-.1-.1-.27.05-.17.16 5.26 5.6 10.18 11.52 15.75 16.83.8.76 2.04-.37 1.26-1.18z"
                    />
                  </g>
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp3"
                      d="M976.29 698.53l-85.32-27.23a8.18 8.18 0 01-5.31-10.29l36.94-115.77c1.38-4.31 5.99-6.69 10.29-5.31l85.32 27.22c4.31 1.38 6.69 5.99 5.31 10.29l-36.94 115.78a8.191 8.191 0 01-10.29 5.31z"
                    />
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp8"
                        d="M994.19 568.05l-41.39-13.26a3.374 3.374 0 01-2.18-4.24l2.58-8.06a3.38 3.38 0 014.24-2.19l41.39 13.26c1.78.57 2.75 2.47 2.18 4.25l-2.58 8.06a3.374 3.374 0 01-4.24 2.18z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp8"
                        d="M993.57 543.68l-2.39 7.44-5.88-1.89 1.09-3.41c.58-1.8-.42-3.74-2.22-4.31l-7.78-2.5a3.44 3.44 0 00-4.31 2.22l-1.09 3.42-5.89-1.89 2.39-7.44a4.948 4.948 0 016.24-3.21l16.62 5.32c2.6.83 4.06 3.62 3.22 6.25z"
                      />
                    </g>
                  </g>
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp5"
                    d="M1017.46 632.14c-3.52-3.3-29.75-14.38-33.63-12.5-4.53 2.2 19.77 14.97 19.69 15.32-.09.44-22.54-14.81-26.53-11.54-2.29 1.87 5.25 8 22.6 18.39-16.13-10.55-25.19-14.97-27.16-13.25-3.35 2.93 20.18 19.86 19.86 20-11-8.46-17.65-12.13-19.93-11.03-2.97 1.42 10.94 13.77 14.98 18.86 4.05 5.09 18.05 2.81 22.08.57 4.04-2.24 12.49-20.64 8.04-24.82z"
                  />
                </g>
              </g>
              <g id="prefix__&lt;Group&gt;">
                <path
                  id="prefix__&lt;Path&gt;"
                  className="prefix__shp1"
                  d="M810.29 422.56c-.52-17.81 27.42-24.17 40.73-25.98 16.96-2.32 31.66-.74 39.28 15.81 7.52 16.35 10.81 35.3 13.26 53.06.45 3.32 5.62 2.7 5.16-.63-2.82-20.47-6.15-59.25-26.34-70.41-19.98-11.05-78.14-1.4-77.26 28.78.1 3.35 5.26 2.7 5.17-.63z"
                />
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp12"
                    d="M919.19 473.45c.8 6.55-3.86 12.51-10.41 13.31-6.56.8-12.51-3.86-13.31-10.41-.8-6.56 3.86-12.52 10.41-13.31 6.56-.8 12.52 3.86 13.31 10.41z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp13"
                    d="M914.47 474.03a7.19 7.19 0 01-6.27 8.01 7.197 7.197 0 01-8.01-6.27 7.19 7.19 0 016.27-8.01 7.19 7.19 0 018.01 6.27z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <g id="prefix__&lt;Group&gt;">
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp6"
                        d="M826.16 478.93c11.19 50.42 8.69 62.53 4.31 68.11-4.6 5.87-11.78 8.87-12.08 8.99l-1.38-3.35.69 1.68-.69-1.68c.06-.03 6.61-2.77 10.61-7.88 3.16-4.03 6.08-15.16-5-65.09l3.54-.78z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp12"
                        d="M821.96 550.32l1.47 2.92c.56 1.09.11 2.44-.98 2.99l-7.24 3.64c-1.1.55-2.44.11-2.99-.99l-1.47-2.92a2.23 2.23 0 01.99-2.99l7.23-3.64c1.1-.55 2.44-.11 2.99.99z"
                      />
                    </g>
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp6"
                        d="M793.54 478.9c-11.38 37.22-14.58 57.72-10.07 64.49 3.61 5.43 9.9 8.66 9.96 8.69l-1.64 3.24c-.29-.15-7.21-3.7-11.34-9.92-5.37-8.07-2.58-27.65 9.62-67.57l3.47 1.07z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp12"
                        d="M788.68 549.34l-1.7 2.79c-.63 1.05-.29 2.43.75 3.06l6.94 4.2c1.04.63 2.42.29 3.05-.75l1.7-2.8c.63-1.05.3-2.43-.75-3.06l-6.94-4.2a2.229 2.229 0 00-3.05.76z"
                      />
                    </g>
                  </g>
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp12"
                    d="M788.88 476.21c1.24-5.16 4.75-17.96 7.44-24.34 1.47-3.5 4.01-6.37 7.61-8.62.72-.05.65-6.39.49-11.58-.16-4.58-.43-9.91.72-11.34 1.11-1.38 3.88-1.37 4.99-.06 1.19 1.39 1.05 6.73 1.03 11.32-.03 5.19.07 11.53.8 11.55 3.43 2.32 5.9 5.16 7.41 8.52 2.54 5.63 6.92 20.55 7.69 24.9.95 5.39-.83 5.99-2.38 6.45-2.2.66-3.52-.87-5-6.86-2.33-9.48-5.12-25.4-11.64-25.61v-.01c-6.51.4-9.79 17.02-12.23 26.26-1.53 5.78-2.79 6.3-5.01 5.7-1.56-.42-3.15-1.14-1.92-6.28z"
                  />
                </g>
              </g>
              <g id="prefix__&lt;Group&gt;">
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M860.65 232.38c-14.07-10.92-31.38-9.59-51.91 3.98-35.09 23.19-24.07 61.25-33.28 83.01-9.21 21.76-31.32 26.88-26.32 51.38 4.29 21 72 26.48 105.97 21.96 41.9-5.57 71.99-20.41 76.36-38.11 4.37-17.7-20.82-28.51-22.63-41.94-1.8-13.43.02-81.96-48.19-80.28z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M790.8 255.66c-5.87 11-10.08 22.48-12.01 34.84-1.31 8.32-1.6 16.67-5.18 24.42-3.31 7.16-8.38 13.14-13.79 18.81-6.86 7.2-14.74 15.06-13.39 25.91 1.16 9.26 8.13 15.58 17.12 17.06.2.03.26-.32.06-.37-7.42-1.84-13.47-7.04-15.23-14.68-1.89-8.22 2.27-15.11 7.54-20.93 6.41-7.08 13.37-13.26 18.06-21.74 4.98-8.98 5.36-18.48 6.79-28.41 1.73-11.99 5.15-23.82 10.09-34.88.02-.04-.04-.06-.06-.03zM933.72 338.54c-5.45-10.68-16.68-16.47-21.71-27.61-9.21-20.37-3.94-45.8-19.93-63.23-.14-.14-.35.06-.23.21 13.36 17.34 10.11 39.95 17.14 59.6 2.92 8.17 7.66 14.1 13.85 20.03 9.5 9.11 17.79 22.17 8.44 34.72-.29.4.34.77.64.4 5.84-7.08 5.91-16.08 1.8-24.12z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M800.52 243.91c-13.49 9.4-18.34 23.34-21.63 38.86-1.83 8.58-3.28 17.25-5.85 25.65-2.87 9.42-7.6 17.48-12.76 25.78-6.59 10.58-14.08 24.68-7.69 37.15 6.98 13.63 24.14 13.6 37.28 13 .37-.02.39-.59.02-.57-16.08.59-38.95-1.6-38.65-23.02.22-15.2 11.63-26.23 18.19-38.97 13.07-25.37 7.26-58.18 31.35-77.53.19-.15-.05-.5-.26-.35z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp5"
                    d="M874.86 404.96c2.31 32.6 1.38 49.56-2.78 50.88-11.95 3.8-35.52-49.9-37.29-53.34-.74-1.49-3.82-14.96-5.73-28.24l-.54-3.99c-.18-1.33-.33-2.6-.46-3.88-.19-1.7-.36-3.36-.53-5.03-.85-8.41-1.62-16.22-2.29-23.42l6.03 1.76 42.2 14.14.89 32.36.07 1.97.01.65.22 9.76v.08l.2 6.3z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp16"
                    d="M874.43 388.17c-4.72 2.12-10.06 3.18-15.94 2.83-12.46-.68-21.73-7.85-29.43-16.74l-.54-3.99c-.18-1.33-.33-2.6-.46-3.88-.19-1.7-.36-3.36-.53-5.03-.85-8.41-1.62-16.22-2.29-23.42l6.03 1.76 42.2 14.14.89 32.36.07 1.97z"
                  />
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M885.09 248.1c12.47 2.23 20.41 11.12 23.83 26.69 4.28 19.45-7.8 37.84-10.21 39.66-4.27 3.23-24.52-53.9-13.62-66.35z"
                  />
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp5"
                    d="M904.02 311.17c1.19 57.33-30.84 61.17-40.56 63-11.03 2.09-54.28 1.31-61.39-55.59-7.11-56.9 19.17-75.58 44.81-77.44 25.64-1.87 55.95 12.7 57.14 70.03z"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp1"
                        d="M851.95 315.13c-.05-.14-.29.22-.26.38.59 3.86.61 8.38-2.75 10.09-.1.05-.07.25.06.21 4.21-1.11 4.12-7.12 2.95-10.68z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp1"
                        d="M848 311.5c-6.29.27-5.28 12.83.54 12.58 5.74-.25 4.73-12.81-.54-12.58z"
                      />
                    </g>
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp1"
                        d="M881.52 312.84c.03-.15.3.19.29.35-.19 3.9.24 8.4 3.74 9.76.11.05.1.24-.03.22-4.3-.69-4.81-6.67-4-10.33z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp1"
                        d="M885.09 308.83c6.28-.36 6.53 12.24.71 12.57-5.73.33-5.99-12.27-.71-12.57z"
                      />
                    </g>
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp16"
                      d="M854.47 344.33c.88.97 1.74 2.28 3.15 2.48 1.35.19 2.97-.33 4.24-.74.13-.05.25.09.16.2-1.1 1.44-3.28 2.26-5.07 1.84-1.74-.41-2.53-1.98-2.87-3.62-.04-.23.26-.3.39-.16z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp1"
                      d="M887.3 298.53c-1.35-.15-2.56-.51-3.88-.8-1.48-.32-2.7-.42-3.8-1.57-.59-.61-.55-1.86-.01-2.49 1.27-1.46 3.18-1.52 4.99-1.2 1.95.34 3.37 1.11 4.67 2.61 1.26 1.45-.19 3.65-1.97 3.45zM842.96 301.46c1.32-.29 2.5-.77 3.78-1.19 1.44-.47 2.64-.69 3.62-1.94.53-.67.36-1.91-.24-2.48-1.4-1.33-3.31-1.19-5.08-.7-1.91.54-3.25 1.44-4.39 3.07-1.1 1.57.56 3.61 2.31 3.24z"
                    />
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp1"
                        d="M869.79 337.73c-1.59 2.58-3.58 4.41-5.96 5.49-1.32.6-2.77.92-4.34.64-3.22-.56-3.54-3.45-3.17-5.97.19-1.39.56-2.69 1.09-3.91 3.31 2.61 7.44 3.86 12.38 3.75z"
                      />
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp11"
                        d="M863.83 343.22c-1.32.6-2.77.92-4.34.64-3.22-.56-3.54-3.45-3.17-5.97 3.4.06 6.94 2.07 7.51 5.33z"
                      />
                    </g>
                    <g id="prefix__&lt;Group&gt;">
                      <path
                        id="prefix__&lt;Path&gt;"
                        className="prefix__shp16"
                        d="M870.79 330.21c.53 3.89.8 6.75.81 8.59 0 .25-.67.38-1.6.43-.05.01-.07.03-.11 0-4.86.76-9.75-.91-12.7-4.87-.19-.27.16-.56.41-.39 3.62 2.66 7.63 3.35 11.94 3.42.19-.76-1.72-9.94-1.28-9.97 1.5-.13 4.46.89 6.24 1.41-1.33-12.2-4.6-24.08-5.75-36.24-.03-.44.59-.57.72-.18 4.32 12.21 6.16 26.21 7.85 38.77.23 1.57-5.43-.5-6.53-.97z"
                      />
                    </g>
                  </g>
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp1"
                    d="M806.07 322.11c6.31.57 11.51-7.64 15.58-24.63 42.47-5.88 63.62-22.34 63.44-49.38-24.16-18.71-47.87-18.64-71.12.21-34.88 28.28-16.55 73.01-7.9 73.8z"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp5"
                      d="M811.47 325.17c-7.54-12.46-14.11-17.38-19.71-14.77-8.39 3.92-.71 30.43 8.57 34.6 6.19 2.78 10.63 1.33 13.31-4.35l-2.17-15.48z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp16"
                      d="M794.15 317.95c-.15-.03-.19.19-.06.25 6.49 3.14 9.6 9.56 11.63 16.13-1.82-2.59-4.43-4.13-7.89-1.98-.19.11-.04.39.15.37 2.78-.41 4.72.2 6.42 2.51 1.2 1.63 1.97 3.65 2.79 5.5.27.62 1.37.37 1.18-.33-.01-.05-.03-.11-.04-.16.73-8.5-5.1-20.83-14.18-22.29z"
                    />
                  </g>
                </g>
                <g id="prefix__&lt;Group&gt;">
                  <path
                    id="prefix__&lt;Path&gt;"
                    className="prefix__shp8"
                    d="M789.8 329.25c1.75 8.56 5.93 15.6 10.83 21.87 6.98 9 17.24 13.5 27.37 17.33 1.01.37 1.37-1.34.32-1.72-11.19-3.88-21.38-12.01-27.19-20.89-.06 0-.06 0-.04-.02-.4-.28-.78-.59-1.16-.9-3.56-1.89-6.84-7-9.02-12.75-.04-.1-.07-.17-.09-.25-.38-.88-.72-1.79-1.02-2.67zM799.71 311.97c2.51 1.46 4.92 3.6 6.96 5.74.02.02.04.02.06.05 1.25 1.15 2.52 2.63 3.73 4.24.41.49.79 1.02 1.15 1.53.42.53.73.95.95 1.26l.01.09c2.76 3.99 5.07 7.97 6.14 9.16.33.39.93-.09.72-.47-2.97-5.53-8.39-20.05-16.56-21.53-1.14-.21-2.21-.23-3.16-.07z"
                  />
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp8"
                      d="M815.1 327.21c-1.36-2.78 19.31 6.36 40.4 1.32 4.31-1.03 16.27-6.29 23-6.5 6.74-.22 14.8 5 24.14 5.71 3.2.24 1.32 27.89-6.44 40.2-2.55 4.05-13.7 12.54-20.64 13.47-16.31 2.2-44.71-8.6-49.14-13.92-3.56-4.27 1.59-13.92-11.32-40.28z"
                    />
                  </g>
                  <g id="prefix__&lt;Group&gt;">
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp6"
                      d="M901.29 336.54c-5.91-2.29-12.42-4.29-18.57-5.3-5.49-.9-10.37 1.25-15.49 3.25-13.72 5.37-27.7 5.25-41.81 1.71-.16-.04-.22.24-.06.31 11.34 4.55 23.51 4.87 35.09 1.8 6.32-1.67 12.57-5.3 19.17-5.1 7.2.23 14.3 3.43 21.45 4.44.61.09.82-.88.22-1.11zM891.96 368.74c-4.35 2.27-8.6 5.52-13.13 7.16-5.43 1.95-11.97.35-17.43-.75-10.33-2.08-20.3-5.98-30.43-9.13-.08-.03-.11.12-.03.15 11.3 5.09 23.05 9.32 35.05 11.06 4.02.59 8.48 1.47 12.43.14 4.77-1.6 9.46-5.33 13.65-8.34.12-.09.03-.36-.11-.29zM898.09 345.93c-10.53-2.75-20.22-1.67-30.76.07-12 1.98-24.03 2.04-36.1.46-.12-.01-.16.19-.04.21 10.7 1.87 21.49 2.12 32.23.66 5.19-.7 10.33-1.84 15.54-2.37 6.45-.65 12.63.29 18.99 1.64.37.08.51-.57.14-.67z"
                    />
                    <path
                      id="prefix__&lt;Path&gt;"
                      className="prefix__shp6"
                      d="M895.96 356.57c-9.77 5.69-19.3 8.32-30.31 7.65-10.86-.66-21.41-4.42-31.88-7.66-.14-.04-.18.2-.05.25 21.04 8.11 42.27 13.37 62.53.38.41-.26.11-.86-.29-.62z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <path
            id="prefix__&lt;Path&gt;"
            className="prefix__shp8"
            d="M186 827.73h1128V846H186v-18.27z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
